export default __webpack_public_path__ + "static/media/btn_googleplay.e0a07ee9.png";